import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { CycleModel } from '../models/CycleModel'
import { Cycle } from '../types/sync'

export const useCurrentCycle = defineStore('currentCycle', () => {
  const cycle = ref<undefined | Cycle>()
  const { writeCycleData } = CycleModel()

  const setCycle = async (data: any, options: { write?: boolean } = { write: true }) => {
    cycle.value = data
    if (options.write) {
      await writeCycleData(data)
    }
  }
  const getCycle = computed(() => {
    return cycle.value
  })
  //Logic to determine if app needs new cycle data
  const requestCycleData = computed(() => {
    const now = new Date()
    if (!cycle.value) return true
    else if (
      new Date(cycle.value.begin_date).getTime() <= now.getTime() &&
      new Date(cycle.value.end_date).getTime() >= now.getTime()
    )
      return false
    else return true
  })

  const resetStoreState = () => {
    void setCycle(undefined, { write: false })
  }
  return {
    setCycle,
    getCycle,
    requestCycleData,
    resetStoreState,
  }
})
